import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "kanban-block-header d-flex align-center flex-wrap ga-2 mb-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_lane_value = _resolveComponent("ontos-lane-value")!
  const _component_ontos_kanban_lane = _resolveComponent("ontos-kanban-lane")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", {
    class: "kanban-block",
    onScrollCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSlide($event)))
  }, [
    (_ctx.labels.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
            return (_openBlock(), _createBlock(_component_ontos_lane_value, {
              key: label.dimension.key,
              named: "",
              value: label,
              context: _ctx.context,
              onLink: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('link', $event)))
            }, null, 8, ["value", "context"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrapper), {
      class: _normalizeClass({'kanban-lanes--slide': _ctx.sliding}),
      style: _normalizeStyle(_ctx.sliding ? _ctx.slideVars : undefined),
      "show-arrows": _ctx.sliding ? 'desktop' : undefined
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lanes, (lane) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: lane.id,
            class: "kanban-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_kanban_lane, {
                lane: lane,
                period: _ctx.periods[lane.id],
                group: _ctx.group,
                "moved-fields": _ctx.movedFields,
                "can-create": _ctx.canCreate,
                "can-write": _ctx.canWrite,
                "create-label": _ctx.createLabelOf(lane),
                "count-title": _ctx.countTitleOf(lane),
                onCreate: ($event: any) => (_ctx.$emit('create', {coordinate: _ctx.coordinate, lane, element: $event})),
                onPeriodChange: ($event: any) => (_ctx.$emit('period-change', {lane, period: $event})),
                onDragStart: ($event: any) => (_ctx.$emit('drag-start', {coordinate: _ctx.coordinate, lane})),
                onChange: ($event: any) => (_ctx.$emit('change', {event: $event, coordinate: _ctx.coordinate, lane}))
              }, {
                default: _withCtx(({ instance }) => [
                  _renderSlot(_ctx.$slots, "default", {
                    instance: instance,
                    coordinate: _ctx.coordinate,
                    lane: lane
                  }, undefined, true)
                ]),
                _: 2
              }, 1032, ["lane", "period", "group", "moved-fields", "can-create", "can-write", "create-label", "count-title", "onCreate", "onPeriodChange", "onDragStart", "onChange"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["class", "style", "show-arrows"]))
  ], 32))
}